'use client'

// The 4 px progress bar (the design system's .job-progress): track on the
// muted surface, value in the signal colour, destructive when stalled.
export function Progress({ value, max = 100, tone = 'signal', label, className = '' }: { value: number; max?: number; tone?: 'signal' | 'danger' | 'success'; label?: React.ReactNode; className?: string }) {
  const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0
  const fill = tone === 'danger' ? 'bg-destructive' : tone === 'success' ? 'bg-success' : 'bg-signal'
  return (
    <div className={`flex items-center gap-3.5 ${className}`}>
      <div className="h-1 flex-1 overflow-hidden rounded-[2px] bg-muted" role="progressbar" aria-valuenow={value} aria-valuemax={max}>
        <div className={`h-full rounded-[2px] transition-[width] ${fill}`} style={{ width: `${pct}%` }} />
      </div>
      {label !== undefined && <span className="w-[65px] shrink-0 text-right font-mono text-label text-muted-foreground">{label}</span>}
    </div>
  )
}
